import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../DeviceView/MyAccount.css";
import "../../DeviceView/LandingRes.css";
import styles from "./Navbar.module.css";
import location_on from "../../assets/UpperNavbar/location_on.svg";
import { CartContext } from "../../Context/CartProvider";
import shopping_bag from "../../assets/shopping_bag.svg";
import Categories from "../Categoris/Categories";

const Navbar = () => {
  const cart = useContext(CartContext);

  const navigate = useNavigate();
  let UserInfo = JSON.parse(localStorage.getItem("userData")) || [];
  let [userName] = useState(UserInfo.fName);
  const handleLogout = () => {
    localStorage.removeItem("userData");
    navigate("/account");
  };
  return (
    <div className={styles.navbar}>
      {/* --------UPPER NAVBAR-------- */}

      <div className={styles.uppernavbar}>
        <div className={styles.uppernavbar_div}>
          <img src={location_on} alt="location" />
          <a href="#">PICK UP IN STORE</a>
          <a href="#">Set Store</a>
        </div>
      </div>

      {/* ---------MIDDLE NAVBAR-------- */}

      <div className={styles.middlenavbar}>
        <div>
          <Link to={"/"}>
            <img
              className={styles.logo}
              src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/Sites-BathAndBodyWorks-Site/-/default/dwe188b42c/images/svg-icons/Logos-main.svg?yocs=o_s_"
              alt="logo"
            />
          </Link>
        </div>
        <div>
          <input placeholder="Search by fragnance or Product..." />
        </div>

        {/* -----account and cart------- */}
        <div style={{ width: "10%" }}>
          <div>
            <Link to="/account">
              <img
                style={{ height: "45px" }}
                id="accImg"
                src="https://www.bathandbodyworks.com/on/demandware.static/Sites-BathAndBodyWorks-Site/-/default/dwc847d762/images/svg-icons/UI-MyAccount.svg"
                alt="account"
              />
            </Link>
          </div>

          <div className={styles.cart}>
            <Link to="/cart">
              <img src={shopping_bag} alt="shopping bag" />
            </Link>
          </div>
        </div>
      </div>
      <Categories />
    </div>
  );
};

export default Navbar;
